import { useNotify } from "ra-core";

/** Notifies a failed finance mutation */
export const useFinanceErrorHandler = () => {
  const notify = useNotify();
  return (error: unknown) =>
    notify(
      error instanceof Error ? error.message : "ra.notification.http_error",
      { type: "error" },
    );
};
